var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","md":"2","justify":"center","align":"center"}},[_c('span',{staticClass:"text-xs-center subtitle font-weight-bold"},[_vm._v(_vm._s(_vm.pieChartLabel))]),_c('div',{ref:"pieChart",staticClass:"chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }